module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Rain2-67366c519e51befb8bb9c616f1ce7593.svg";